import React from "react";
import { Link } from "react-router-dom";
import { navItems } from "../../static/data";
import styles from "../../styles/styles";
import { motion } from "framer-motion";

const Navbar = ({ active }) => {
  return (
    <motion.div
      initial={{ y: 30, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5 }}
      className={`block 800px:${styles.noramlFlex}`}
    >
      {navItems &&
        navItems.map((i, index) => (
          <div className="flex">
            <Link
              to={i.url}
              className={`${
                active === index + 1
                  ? "text-yellow font-bold"
                  : "text-black 800px:text-primary"
              } hover:text-[#767676] pb-[30px] 800px:pb-0 font-light px-6 cursor-pointer text-base text-[#767676] hover:underline underline-offset-[4px] decoration-[1px] md:border-r-[2px] border-r-gray-300 hoverEffect last:border-r-0}`}
            >
              {i.title}
            </Link>
          </div>
        ))}
    </motion.div>
  );
};

export default Navbar;
